import { useTranslation } from "../../hooks/useTranslation";

export function ClaimFilter({ filter, setFilter }) {
  const { t } = useTranslation();

  const isFilterState = (state) => {
    return filter.state?.includes(state);
  };

  const toggleFilterState = (state) => {
    const current = filter.state || [];
    if (current.includes(state)) {
      setFilter({
        ...filter,
        state: current.filter((s) => s !== state),
      });
    } else {
      setFilter({
        ...filter,
        state: [...current, state],
      });
    }
  };

  return (
    <div className="d-lg-flex justify-content-end text-end text-md-start">
      <span className="d-none d-md-inline">
        <button
          type="button"
          className={
            "btn me-3 mb-2 " +
            (isFilterState("open") ? "btn-warning" : "btn-secondary")
          }
          onClick={() => toggleFilterState("open")}
        >
          {t("claims.stateOpen")}
        </button>
        <button
          type="button"
          className={
            "btn me-3 mb-2 " +
            (isFilterState("in_progress") ? "btn-info" : "btn-secondary")
          }
          onClick={() => toggleFilterState("in_progress")}
        >
          {t("claims.stateInProgress")}
        </button>
        <button
          type="button"
          className={
            "btn me-3 mb-2 " +
            (isFilterState("closed") ? "btn-success" : "btn-secondary")
          }
          onClick={() => toggleFilterState("closed")}
        >
          {t("claims.stateClosed")}
        </button>
      </span>
    </div>
  );
}
